export const Urls = {
  HOME_URL: "/",
  ABOUT_URL: "/about",
  NEWS_URL: "/news",
  CONTACT_URL: "/contact",
  DISCUSSIONS_URL: "/discussions",
  REVIEWS_STORIES_URL: "/about/reviews-stories",
  ABOUT_US_URL: "/about/about-us",
  CONTRIBUTORS_URL: "/about/contributors",
  VALUE_ETHICS_URL: "/about/values-ethics",
  PARTNERS_URL: "/about/partners",
  EVENTS_URL: "/events",
  COMMUNITY_URL: "/community",
  HUBDEV_URL: "/hubdev",
  SETTINGS_URL: "/settings",
  NOTIFICATIONS_URL: "/notifications",
  PROFILE_URL: "/profile",
  POSTS_URL: "/profile/posts",
  PROFILE_ABOUT_URL: "/profile/profile-about",
  INTERESTED_EVENTS_URL: "/profile/interested-events",
  FOLLOWED_COMMUNITIES_URL: "/profile/followed-communities",
  LOGIN_URL: "/login",
  OTP_URL: "/otp",
  FOGOT_PASSWORD_URL: "/forgot-password",
  REGISTER_URL: "/register",
  RESET_PASSWORD_URL: "/reset-password",
  LOGIN_CONTACT_URL: "/login-contact",
  POLICY_URL: "/policy",
  LANDING_URL: "/",
  SEARCH_RESULTS_URL: "/search-results",
  SUGGESTION_URL: "/suggestion",
  TRAINER_URL: "/trainers",
  MENTORS_URL: "/mentors",
  NEW_REQUESTS: "/new-requests",
  SSO_LOGIN_URL:"/sso-login"
};
export const genderConverterToBoolean = {
  male: true,
  female: false,
};
export const imgTypes = [
  "tif",
  "tiff",
  "bmp",
  "jpg",
  "jpeg",
  "gif",
  "png",
  "raw",
  "jfif",
  "svg",
];
export const videoTypes = [
  "3gp",
  "avi",
  "flv",
  "mkv",
  "mov",
  "mp4",
  "mpeg",
  "mpg",
  "ogg",
  "rm",
  "vob",
  "webm",
  "wmv",
  "mp3",
];
export const fileTypes = [
  "tif",
  "tiff",
  "bmp",
  "jpg",
  "jpeg",
  "gif",
  "png",
  "raw",
  "jfif",
  "3gp",
  "avi",
  "flv",
  "mkv",
  "mov",
  "mp4",
  "mpeg",
  "mpg",
  "ogg",
  "rm",
  "vob",
  "webm",
  "wmv",
  "doc",
  "docx",
  "ppt",
  "pptx",
  "xlsx",
  "xls",
  "pdf",
  "mp3",
];
export const docType = ["pdf", "doc", "docx", "txt", "pptx", "xlsx"];
export const mainDocType = ["doc", "docx", "txt", "pptx", "xlsx", "csv"];

export const modalType = {
  RateModal: "RateModal",
  EditRateModal: "EditRateModal",
  SendCourse: "SendCourse",
  MyDevContent: "MyDevContent",
  MyDevCourse: "MyDevCourse",
  MyDevImage: "MyDevImage",
  MyDevItem: "MyDevItem",
  MyDevLink: "MyDevLink",
  SendPlayList: "SendPlayList",
  NewStage: "NewStage",
  MyDevFile: "MyDevFile",
  BookSession: "BookSession",
  Confirm: "Confirm",
  Request: "Request",
  Generate: "Generate",
  Create: "Create",
  Update: "Update",
  Update_Skill: "Update_Skill",
  View: "View",
  Accept: "Accept",
  Delete: "Delete",
  Finalisation: "Finalisation",
  AddConclusion: "AddConclusion",
};
export const ACCORDION_TYPE = {
  SESSION_HISTORY: "SESSION_HISTORY",
  FEEDBACKS: "FEEDBACKS",
  MENTOR_RATES: "MENTOR_RATES",
};
export const Tabs = {
  CourseTab: "CourseTab",
  ContentTab: "ContentTab",
};
export const itemType = {
  HubDevCourse: "HubDevCourse",
  HubDevFile: "HubDevFile",
  HubDevLink: "HubDevLink",
  HubDevDiscussion: "HubDevDiscussion",
  HubDevNews: "HubDevNews",
  HubDevCommunityDiscussion: "HubDevCommunityDiscussion",
};
export const contentTypes = {
  TEAM_CONTENT: 2,
  ABOUT_CONTENT: 15,
  CONTRIBUTORS_CONTENT: 5,
  PARTNERS_CONTENT: 8,
  STORY_CONTENT: 4,
  REVIEW_CONTENT: 3,
  VALUES_CONTENT: 6,
  ETHICS_CONTENT: 7,
  CONTACT_CONTENT: 11,
  HOME_CONTENT: 10,
  STEP_CONTACT_CONTENT: 17,
  STEP_SECOND_CONTACT_CONTENT: 18,
  STEP_THIRD_CONTACT_CONTENT: 19,
  POLICY_CONTENT: 13,
  LIBRARY_CONTENT: 14,
  SUGGEST_CONTENT: 12,
};
export const Status_Types = {
  APPLY: 0,
  UNABLE_JOIN: 2,
  INTERESTED: 3,
  ACCEPT: 1,
  PENDING: 1,
};
export const MENTOR_TABS = {
  MENTOR_LIST: "MENTOR_LIST",
  SUGGESTED_MENTORS: "SUGGESTED_MENTORS",
  YOUR_SESSIONS: "YOUR_SESSIONS",
  REQUESTS: "REQUESTS",
  MY_MENTEES: "MY_MENTEES",
};
export const CONTACT_TABS = {
  CONTACT_US: "CONTACT_US",
  SHARE_SUGGESTION: "SHARE_SUGGESTION",
};
export const NOTIFICATION_TABS = {
  ALL: "ALL",
  UNREAD: "UNREAD",
};
export const NEWS_TABS = {
  NEWS: "NEWS",
  ACCOUNCEMENTS: "ACCOUNCEMENTS",
};

export const MENTOR_STATUS = {
  Requested: {
    id:1,
    key: "Requested",
    label: "Requested",
    className: "status-grey",
  },
  Active: {
    id:2,
    key: "Active",
    label: "Active",
    className: "status-green",
  },
  Finished: {
    id:3,
    key: "Finished",
    label: "Finished",
    className: "status-yellow",
  },
  Rejected: {
    id:4,
    key: "Rejected",
    label: "Rejected",
    className: "status-red",
  },
  FinalisationRequested: {
    id:5,
    key: "FinalisationRequested",
    label: "Finalisation Requested",
    className: "status-red",
  },
 
};
export const COMMUNITY_STATUS =  {
  APPLY: 0,
  ACCEPT: 1,
  UNABLE_JOIN: 2,
  PENDING: 3,
  JOINED: 4,
}
export const TAB = {
  DISCUSSION: "1",
  EVENTS: "2",
  MEMBERS: "3",
  ABOUT: "4",
};